<template>
    <el-form-item @mouseenter.stop.native="controlMouseOver(component, index)" @click.native="controlClick(component, index)" :class="{getClassByCopy,'hidden':component.properties.sortType==='hidden','to-top':component.properties.sortType==='toTop'}" :prop="getProp" :rules="component.properties.rules" :label="component.properties.sortType==='hidden' ? '' : labelParameter.labelName" :title="component.name" :label-width="labelParameter.width">
      <div v-if="labelParameter.showSlot" :class="['control-label', labelParameter.className]" slot="label">{{labelParameter.labelName}}</div>
      <el-tooltip class="component-explain-tooltip" v-if="component.properties.componentExplain" :content="component.properties.componentExplain" placement="bottom-start">
        <span class="fa fa-question-circle"></span>
      </el-tooltip>
      <el-input :value="uuid"
                :class="[inputWidth && Number(inputWidth) < 30 && 'clear-padding']"
                :style="{width: inputWidth ? inputWidth + 'px' : '100%', maxWidth: '100%'}"
                :readonly="true"></el-input>
    </el-form-item>
</template>

<script>
import { componentMixin, inputMixin } from './mixins'
import { UUID } from '@/plugins/common'
export default {
  name: 'rc-uuid',
  mixins: [ componentMixin, inputMixin ],
  inject: ['initState'],
  props: [ 'component', 'value', 'index', 'labelParameter', 'tableCtrlKey' ],
  data () {
    return {
      uuid: ''
    }
  },
  watch: {
    'initState.state' (val) {
      if (val) {
        this.initComponent()
      }
    }
  },
  methods: {
    initComponent () {
      if (this.value !== '') {
        this.uuid = this.value
      } else {
        this.uuid = UUID.create()
        this.update(this.uuid)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/form/runtime/components/rc-uuid.vue